import { Component, inject, type OnDestroy, type OnInit } from '@angular/core'
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar'
import { LocaleService } from '@core/locale/locale.service'
import { IS_NUMERIC_AND_SAFE } from '@core/util/check.util'
import { TO_ANY_ARRAY, TO_NUMBER } from '@core/util/convert.util'
import { TO_STRING } from '@core/util/string.util'
import { interval } from 'rxjs'
import { takeWhile, tap } from 'rxjs/operators'

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent implements OnInit, OnDestroy {
  MAT_SNACK_BAR_DATA = inject(MAT_SNACK_BAR_DATA)
  MatSnackBarRef = inject(MatSnackBarRef)
  LocaleService = inject(LocaleService)

  bAlive = false

  panelClass = TO_ANY_ARRAY(this.MAT_SNACK_BAR_DATA.panelClass).map(TO_STRING)

  message = TO_STRING(this.MAT_SNACK_BAR_DATA.message)

  closeString = TO_STRING(this.MAT_SNACK_BAR_DATA.closeString)

  closeClass = TO_ANY_ARRAY(this.MAT_SNACK_BAR_DATA.closeClass).map(TO_STRING)

  durationSec = (() => {
    const rawDurationSec = TO_NUMBER(this.MAT_SNACK_BAR_DATA.duration) / 1e3
    return (IS_NUMERIC_AND_SAFE(rawDurationSec) && (rawDurationSec > 9)) ? rawDurationSec : NaN
  })()

  durationSecD = this.LocaleService.localizeNumber({ value: this.durationSec })

  ngOnInit (): void {
    this.bAlive = true

    if (!Number.isNaN(this.durationSec)) {
      interval(1000)
        .pipe(
          takeWhile(() => this.bAlive && (this.durationSec > 1)),
          tap(() => {
            this.durationSec -= 1
            this.durationSecD = (this.durationSec < 2) ? '' : this.LocaleService.localizeNumber({ value: this.durationSec })
          })
        )
        .subscribe()
    }
  }

  close (): void {
    this.MatSnackBarRef.dismiss()
  }

  ngOnDestroy (): void {
    this.bAlive = false
  }
}
